import React, { useEffect } from 'react';

/**
 * Public support page for Strava API review. Copy is exact per requirements.
 */
const Support: React.FC = () => {
  useEffect(() => {
    document.title = 'Wingo Support';
    return () => {
      document.title = 'Wingo';
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
      <div className="container mx-auto max-w-prose">
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm px-6 py-8 sm:px-8 sm:py-10">
          <p className="text-gray-700 text-base sm:text-lg leading-relaxed whitespace-pre-line">
            For questions about account access, data usage, or to request data removal, contact:

            egoldwein@gmail.com.

            Users can revoke Strava access at any time through their Strava account settings. When access is revoked, the application will no longer read new activity data.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Support;
